import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { RouterLinkResolverService } from '@core/shared/feature';
import * as i0 from "@angular/core";
export let AccessbilityLinkComponent = /*#__PURE__*/(() => {
  class AccessbilityLinkComponent {
    constructor() {
      this.resolver = inject(RouterLinkResolverService);
    }
    static {
      this.ɵfac = function AccessbilityLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessbilityLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: AccessbilityLinkComponent,
        selectors: [["accessibility-link"]],
        decls: 7,
        vars: 1,
        consts: [["uiButton", "", "title", "Barrierefreiheit-Einstellungen", 3, "routerLink"], ["xmlns", "http://www.w3.org/2000/svg", "width", "48", "height", "48", "viewBox", "0 0 24 24", "fill", "none", "stroke", "currentColor", "stroke-width", "1.8", "stroke-linecap", "round", "stroke-linejoin", "round", "aria-hidden", "true"], ["d", "M21 12 C21 16.97 16.97 21 12 21 7.02 21 3 16.97 3 12 3 7.02 7.02 3 12 3 16.97 3 21 7.02 21 12 z"], ["fill", "currentColor", "d", "M13.8 7.2 C13.8 8.19 12.99 9 12 9 11 9 10.19 8.19 10.19 7.2 10.19 6.2 11 5.4 12 5.4 12.99 5.4 13.8 6.2 13.8 7.2 z"], ["d", "M7.8 11h8.4"], ["d", "M12 9.8v5"], ["d", "M10 18l2-3 2 3"]],
        template: function AccessbilityLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "path", 2)(3, "path", 3)(4, "path", 4)(5, "path", 5)(6, "path", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("routerLink", ctx.resolver.resolveRouterLink("frontend", "accessibility"));
          }
        },
        dependencies: [RouterLink, UiButtonComponent],
        styles: ["a[_ngcontent-%COMP%]{position:fixed;right:0;bottom:15%;border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;--buttonHoverBgColor:var(--accentColor)!important}\n\n/*# sourceMappingURL=accessibility-link.component.ts-angular-inline--50.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return AccessbilityLinkComponent;
})();